import { render, staticRenderFns } from "./add-device-undefined-gdpr-approve.vue?vue&type=template&id=79f0302e&scoped=true&"
import script from "./add-device-undefined-gdpr-approve.js?vue&type=script&lang=js&"
export * from "./add-device-undefined-gdpr-approve.js?vue&type=script&lang=js&"
import style0 from "./add-device-undefined-gdpr-approve.css?vue&type=style&index=0&id=79f0302e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f0302e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
